import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { inject, Injector, ApplicationRef } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthTokenService } from '@shared/services/auth-token.service';
import { ImpersonationService } from '@shared/services/impersonation.service';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  const tokenService = inject(AuthTokenService);
  const impersonation = inject(ImpersonationService);

  const impToken = impersonation.getToken();
  const token = tokenService.getToken();
  const headers: any = {
    'Accept': 'application/json',
  };

  // Impersonation token takes precedence: while it is present the club app runs
  // as the impersonated user (distinct scheme so the backend routes it to
  // ImpersonationTokenAuthentication, not TokenAuthentication).
  if (impToken) {
    headers['Authorization'] = `Impersonate ${impToken}`;
  } else if (token) {
    headers['Authorization'] = `Token ${token}`;
  }

  let url = req.url;
  if (environment.apiUrl && !url.startsWith('http')) {
    url = `${environment.apiUrl}${url}`;
  }

  const apiReq = req.clone({
    url: url,
    setHeaders: headers,
  });

  return next(apiReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const appRef = injector.get(ApplicationRef);
      if (error.status === 401) {
        // An expired/revoked impersonation token: drop it and return to the staff
        // app, instead of the normal participant logout flow.
        if (impersonation.getToken()) {
          impersonation.clear();
          setTimeout(() => {
            try { window.location.href = environment.staffUrl; } catch {}
          }, 0);
          return throwError(() => error);
        }
        const hadToken = !!tokenService.getToken();
        tokenService.clearToken();
        // Defer navigation to avoid DI cycles during APP_INITIALIZER
        if (hadToken) {
          setTimeout(() => {
            try {
              const router = injector.get(Router);
              if (router.url !== '/') {
                router.navigate(['/']);
              }
            } catch {}
          }, 0);
        }
      }
      if (error.status === 500) {
        // Defer navigation to avoid DI cycles during APP_INITIALIZER
        setTimeout(() => {
          try {
            const router = injector.get(Router);
            const from = router.url;
            if (!from.includes('/server-error')) {
              router.navigate(['/server-error'], { queryParams: { from } });
            }
          } catch {}
        }, 0);
      }
      return throwError(() => error);
    })
  );
};
